const preTitle = {
  fontFamily: 'SackersGothicStd, sans-serif',
  fontSizeSmall: '14px',
  fontSizeMedium: '16px',
  lineHeightSmall: '24px',
  lineHeightMedium: '24px',
  fontWeight: '850'
}

const title = {
  fontFamily: 'SackersGothicStd, sans-serif',
  fontSizeSmall: '32px',
  fontSizeMedium: '48px',
  lineHeightSmall: '40px',
  lineHeightMedium: '60px',
  widthSmall: '310px',
  widthMedium: '420px',
  fontWeight: '850'
}

const textStyles = {
  name: '4',
  type: 'Paragraph',
  lineHeight: '17.5px',
  lineHeightDesktop: '17.5px'
}

const loyaltyHero = {
  preTitle,
  title,
  textStyles
}

export default loyaltyHero
